/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;justify-content:center;align-items:center;height:100%}.login-card[_ngcontent-%COMP%]{width:300px}.login-form[_ngcontent-%COMP%]{display:flex;flex-direction:column}.login-button[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:stretch}.far[_ngcontent-%COMP%]{font-size:15px}"];
export { styles as styles };
